export default __webpack_public_path__ + "static/media/TITULOS_01.510a2bcf.png";